var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated revealUp"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',[_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t("stocktakesummary")))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"white-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"dropdown-curve-container"},[_c('label',{class:_vm.selectedCinema.length > 0 ? 'shift-up' : ''},[_vm._v(_vm._s(_vm.$t("select"))+" "+_vm._s(_vm.$tc("cinema", 1)))]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"dropdown-curve-container"},[_c('multiselect',{attrs:{"options":_vm.cinemasList,"searchable":true,"label":"cine_name","track-by":"cine_id","placeholder":'Select CInema',"showLabels":false,"multiple":true,"group-values":"Cinemas","group-label":"label","group-select":true},model:{value:(_vm.selectedCinema),callback:function ($$v) {_vm.selectedCinema=$$v},expression:"selectedCinema"}})],1)])]),_vm._v(" "),_c('p',{staticClass:"error_message"},[(_vm.submitted && _vm.selectedCinema.length == 0)?_c('span',[_vm._v("Please Select Cinema.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"input-material"},[_c('div',{staticClass:"add-datepicker"},[(_vm.fromDate)?_c('button',{staticClass:"btn-clearDate",on:{"click":function($event){_vm.fromDate = null}}},[_vm._v("\n              ✖\n            ")]):_vm._e(),_vm._v(" "),_c('Datepicker',{attrs:{"monday-first":true,"typeable":""},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('label',{class:_vm.fromDate ? 'active' : ''},[_vm._v(_vm._s(_vm.$t("from"))+" "+_vm._s(_vm.$t("date")))])],1)]),_vm._v(" "),_c('p',{staticClass:"error_message"},[(_vm.submitted && _vm.fromDate == null)?_c('span',[_vm._v("Please Select From Date.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"input-material"},[_c('div',{staticClass:"add-datepicker"},[(_vm.toDate)?_c('button',{staticClass:"btn-clearDate",on:{"click":function($event){_vm.toDate = null}}},[_vm._v("\n              ✖\n            ")]):_vm._e(),_vm._v(" "),_c('Datepicker',{attrs:{"monday-first":true,"typeable":""},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('label',{class:_vm.toDate ? 'active' : ''},[_vm._v(_vm._s(_vm.$t("to"))+" "+_vm._s(_vm.$t("date")))])],1)]),_vm._v(" "),_c('p',{staticClass:"error_message"},[(_vm.submitted && _vm.toDate == null)?_c('span',[_vm._v("Please Select To Date.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn-blue",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.getStockTakeLogs()}}},[_vm._v("\n          "+_vm._s(_vm.$t("fetch"))+"\n        ")])]),_vm._v(" "),(_vm.groupedData && _vm.groupedData.length > 0)?_c('div',{staticClass:"d-flex justify-content-end align-items-center w-100 mr-4 mb-2"},[_c('div',[_vm._v(_vm._s(_vm.$t("download"))+" as:")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"download":"","target":"_blank","title":"Download as Excel"},on:{"click":function($event){return _vm.getStockTakeLogs('Y')}}},[_c('img',{staticClass:"mx-1",attrs:{"height":"25","src":require("@/assets/img/icons/excel.svg"),"width":"25"}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"swc-report"},[_c('table',{staticClass:"swc-report-table"},[_c('thead',[_c('tr',{staticClass:"bg-lightgrey"},[_c('th',[_vm._v("Cinema Name")]),_vm._v(" "),_c('th',[_vm._v("RM Category")]),_vm._v(" "),_c('th',[_vm._v(_vm._s("System Calculated Stock (SCS)"))]),_vm._v(" "),_c('th',[_vm._v(_vm._s("Counted Stock (CS)"))]),_vm._v(" "),_c('th',[_vm._v(_vm._s("Variance (CS -SCS)"))]),_vm._v(" "),_c('th',[_vm._v(_vm._s("SCS Value (SCSV)"))]),_vm._v(" "),_c('th',[_vm._v(_vm._s("CS Value (CSV)"))]),_vm._v(" "),_c('th',[_vm._v(_vm._s("Variance Value"))])])]),_vm._v(" "),(_vm.groupedData.length > 0)?_c('tbody',[_vm._l((_vm.groupedData),function(cinemaGrp,cinemaIndex){return [_vm._l((cinemaGrp.categoryArray),function(catGrp,catIndex){return [_c('tr',{key:cinemaIndex + '_' + catIndex},[_c('td',[_vm._v(_vm._s(cinemaGrp.cinema_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(catGrp.category_name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.currFormat(
                      catGrp.itemsArray.reduce(function (
                        accumulator,
                        ref
                      ) {
                        var system_calculated_stock = ref.system_calculated_stock;

                        return (
                          accumulator + parseFloat(system_calculated_stock)
                        );
                      },
                      0)
                    ))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.currFormat(
                      catGrp.itemsArray.reduce(function (
                        accumulator,
                        ref
                      ) {
                        var counted_stock = ref.counted_stock;

                        return accumulator + parseFloat(counted_stock);
                      },
                      0)
                    ))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.currFormat(
                      catGrp.itemsArray.reduce(function (
                        accumulator,
                        ref
                      ) {
                        var variance = ref.variance;

                        return accumulator + parseFloat(variance);
                      },
                      0)
                    ))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.currFormat(
                      catGrp.itemsArray.reduce(function (
                        accumulator,
                        ref
                      ) {
                        var system_calculated_stock_value = ref.system_calculated_stock_value;

                        return (
                          accumulator +
                          parseFloat(system_calculated_stock_value)
                        );
                      },
                      0)
                    ))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.currFormat(
                      catGrp.itemsArray.reduce(function (
                        accumulator,
                        ref
                      ) {
                        var counted_stock_value = ref.counted_stock_value;

                        return accumulator + parseFloat(counted_stock_value);
                      },
                      0)
                    ))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.currFormat(
                      catGrp.itemsArray.reduce(function (
                        accumulator,
                        ref
                      ) {
                        var variance_value = ref.variance_value;

                        return accumulator + parseFloat(variance_value);
                      },
                      0)
                    ))+"\n                  ")])])]}),_vm._v(" "),_c('tr',{key:cinemaIndex + '_1',staticClass:"bg-lightgrey"},[_c('td',[_vm._v("Total")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    cinemaGrp.categoryArray.reduce(
                      function (acc, catGrp) { return acc +
                        catGrp.itemsArray.reduce(function (
                          accumulator,
                          ref
                        ) {
                          var system_calculated_stock = ref.system_calculated_stock;

                          return (
                            accumulator + parseFloat(system_calculated_stock)
                          );
                        },
                        0); },
                      0
                    )
                  ))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    cinemaGrp.categoryArray.reduce(
                      function (acc, catGrp) { return acc +
                        catGrp.itemsArray.reduce(function (
                          accumulator,
                          ref
                        ) {
                          var counted_stock = ref.counted_stock;

                          return accumulator + parseFloat(counted_stock);
                        },
                        0); },
                      0
                    )
                  ))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    cinemaGrp.categoryArray.reduce(
                      function (acc, catGrp) { return acc +
                        catGrp.itemsArray.reduce(function (
                          accumulator,
                          ref
                        ) {
                          var variance = ref.variance;

                          return accumulator + parseFloat(variance);
                        },
                        0); },
                      0
                    )
                  ))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    cinemaGrp.categoryArray.reduce(
                      function (acc, catGrp) { return acc +
                        catGrp.itemsArray.reduce(function (
                          accumulator,
                          ref
                        ) {
                          var system_calculated_stock_value = ref.system_calculated_stock_value;

                          return (
                            accumulator +
                            parseFloat(system_calculated_stock_value)
                          );
                        },
                        0); },
                      0
                    )
                  ))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    cinemaGrp.categoryArray.reduce(
                      function (acc, catGrp) { return acc +
                        catGrp.itemsArray.reduce(function (
                          accumulator,
                          ref
                        ) {
                          var counted_stock_value = ref.counted_stock_value;

                          return (
                            accumulator + parseFloat(counted_stock_value)
                          );
                        },
                        0); },
                      0
                    )
                  ))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.currFormat(
                    cinemaGrp.categoryArray.reduce(
                      function (acc, catGrp) { return acc +
                        catGrp.itemsArray.reduce(function (
                          accumulator,
                          ref
                        ) {
                          var variance_value = ref.variance_value;

                          return accumulator + parseFloat(variance_value);
                        },
                        0); },
                      0
                    )
                  ))+"\n\n                ")])])]}),_vm._v(" "),(_vm.groupedData.length == 0)?_c('tr',{staticClass:"w-100"},[_vm._m(0)]):_vm._e()],2):_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":"14"}},[_c('NoRecords')],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"14"}},[_c('h6',{staticClass:"mb-0"},[_vm._v("\n                No Records Found\n                "),_c('br')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb510928","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/FoodAndBeveragesContainer/StockComponents/stockTakeLogSummary.vue
// module id = null
// module chunks = 